export default [
    {
        key: 'DimensionMapIssuedModal',
        getComponent: function () { return import('./DimensionMapIssuedModal'); },
        title: i18n.get('档案关系'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal'
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800
    }
];
